<script setup>
import {onMounted, ref} from "vue";
import DocumentsListMinimalComponent from "../../components/documents/DocumentsListMinimalComponent.vue";
import router from '@/router';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
onMounted(() => {
});

</script>

<template>


  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-2">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> Zpět</a>
        </div>
        <div class="col-8 text-center">
          <div class="page-section__title">
            {{ t('myDocumentsIndex.my_documents') }}
          </div>
        </div>
      </div>
    </div>
    <div class="page-section__content">
      <div class="row mt-3">
        <div class="col-12">
          <div class="card">

            <div class="card-header">
              <div class="row">
                <div class="col">
                  <div class="card-header__title">
                    {{ t('myDocumentsIndex.to_processing') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <DocumentsListMinimalComponent/>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <div class="card">

            <div class="card-header">
              <div class="row">
                <div class="col">
                  <div class="card-header__title">
                    {{ t('myDocumentsIndex.archived') }}
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <DocumentsListMinimalComponent :archive="true"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
